import { useEffect, useState } from 'react'

let isDialogOpenState = false
let listeners = []

const setPricingPlansDialogState = (state) => {
    isDialogOpenState = state
    listeners.forEach(listener => listener(isDialogOpenState))
}

const subscribe = (listener) => {
    listeners.push(listener)
    return () => {
        listeners = listeners.filter(l => l !== listener)
    }
}


export const usePricingPlans = () => {
    const [isDialogOpen, setIsDialogOpen] = useState(isDialogOpenState)

    useEffect(() => {
        const unsubscribe = subscribe(setIsDialogOpen)
        return () => unsubscribe()
    }, []);

    return isDialogOpen
}

export const togglePricingPlansDialog = (state) => setPricingPlansDialogState(state)